import { constants, Styles, theme } from '@/styles';

export const styles: Styles = {
  overflow: 'hidden',

  '.error-section': {
    paddingTop: constants.offset.small,
    paddingBottom: constants.offset.large,

    '&__title': {
      color: theme.error,
    },

    '&__description': {
      marginTop: constants.offset.xsmall,
    },
  },

  '.link': {
    marginLeft: constants.offset.xsmall,
  },
};
